import {styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import Logo from '../assets/icons/logo.jsx';
import {FRAME_PADDING} from '../constants.js';

const Container = styled('div')({
  padding: FRAME_PADDING,
  position: 'absolute',
  bottom: 0,
  left: 0,
  transformOrigin: 'bottom left',
});

const StyledLogo = styled(Logo)({
  height: 64,
  fill: 'currentColor',
});

const FrameLogo = props => (
  <Container style={{transform: `scale(${props.scale})`}}>
    <StyledLogo />
  </Container>
);

FrameLogo.propTypes = {
  scale: PropTypes.number.isRequired,
};

export default FrameLogo;
